import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import { ResponsiveBarCanvas } from "@nivo/bar";
import { instance } from "Actions/AxiosInstance";
import defaultEmp from "Assets/Images/defaultEmp.svg";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import React from "react";
import { Link } from "react-router-dom";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import DrawerHeader from "Component/Headers/drawerHeader";
import Drawer from "@material-ui/core/Drawer";
import { getFormattedImageLink } from "../../../Utils";
import ShareIdea from "./ShareIdea";

class Hrops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      longestday: 10,
      DrawerOpen: false,
      offset: 0,
      limit: 5,
      averagetime: null,
      ldsubfiltertypeid: 1,
      checklistList: [],
      employeeexpenditure: [],
      wffiltertypeid: 1,
      wfsubfiltertypeid: 1,
      wfsubfilterids: [],
      atfiltertypeid: 1,
      atsubfiltertypeid: 1,
      atsubfilterids: null,
      expenseheatmap: [],
      tempList: [],
      fullcount: "",

      drawerchecklistdata: [
        {
          triggertypecount: {
            triggered: null,
            manual: null,
          },
          fullcount: null,
          checklist: [
            {
              checklistid: 405,
              checklistname: "On-boadring Task list",
              assignemployeelist: [
                {
                  employeeid: 7610,
                  fullname: "Vivek Jain",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
              ],
            },
          ],
        },
      ],
      checklistdata: [
        {
          triggertypecount: {
            triggered: null,
            manual: null,
          },
          fullcount: null,
          checklist: [
            {
              checklistid: 405,
              checklistname: "On-boadring Task list",
              assignemployeelist: [
                {
                  employeeid: 7610,
                  fullname: "Vivek Jain",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7617,
                  fullname: "Sharmeen Jhunjhunwala",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7609,
                  fullname: "Twinkle Nikam",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7607,
                  fullname: "Vikas Sharma",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7613,
                  fullname: "Chetan Rane",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7682,
                  fullname: "Shweta Parkar",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7684,
                  fullname: "rohit",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7685,
                  fullname: "sukhavinder",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7611,
                  fullname: "Hrishikesh Dcosta",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7616,
                  fullname: "Radhika Patel",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7608,
                  fullname: "Grishma Singh",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7612,
                  fullname: "Siddhi Gupta",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
                {
                  employeeid: 7683,
                  fullname: "kunal",
                  imagepath: null,
                  checklistid: 405,
                  fullcount: 92,
                },
              ],
            },
          ],
        },
      ],

      fromdate: "",
      todate: "",
      expensedistribution: [],
      averageexpense: 0,
      highestexpenditurelocation: null,
      maximumexpenditurmonth: null,
      compensatorstattype: 6,
      checklistTypes: [
        { displayvalue: "1", displayname: "Most triggered" },
        { displayvalue: "2", displayname: "Least triggered" },
      ],
      requestCountData: [],
      employeewalletbalancedata: [],
      unclaimedwalletbalancedata: [],
      totalbalance: 0,
      eefiltertypeid: 1,
      eesubfiltertypeid: 1,
      eesubfilterids: [],

      requestcounttype: 1,
      teamfullcount1: 200,
    };

    this.selectFilter = this.selectFilter.bind(this);
    this.viewmore = this.viewmore.bind(this);
  }

  componentDidMount() {
    this.getCheklistFrequency();
    this.getChecklistData();
    this.getchecklistcomplteiontime();
  }

  getCheklistFrequency() {
    let name;
    instance
      .post("resolve/checklistbyfrequency", {
        isleast: this.state.requestcounttype == 1 ? false : true,
      })
      .then((result) => {
        const data = [];
        result.data.result &&
          result.data.result.forEach((d) => {
            name = d.checklistname;
            name = name.split(" ");
            name = `${name[0]} ${name[name.length - 1]}`;
            data.push({
              name,
              Value: d.checklistorder,
              displayvalue: d.checklistorder,
              displayname: d.checklistname,
            });
          });
        this.setState({
          requestCountData: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getCount = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  getChecklistData() {
    instance
      .post("resolve/getongoingchecklist", {
        limit: this.state.limit,
        offset: this.state.offset,
      })
      .then((result) => {
        const checklistdata = result.data.result ? result.data.result : [];
        // let checklistList = [];
        // const fullcount =
        //   checklistdata[0].checklist.length > 0
        //     ? checklistdata[0].checklist[0].assignemployeelist[0].fullcount
        //     : 0;
        // result.data.result.length > 0
        //   ? (checklistList = [
        //       ...this.state.checklistList,
        //       ...checklistdata[0].checklist,
        //     ])
        //   : (checklistList = this.state.checklistList);
        // const teamfullcount1 =
        //   this.state.checklistdata.checklist.assignemployeelist > 0
        //     ? this.state.checklistdata.assignemployeelist[0].fullcount
        //     : 0;
        this.setState({
          checklistdata,
          // offset: this.state.offset + this.state.limit,
          // fullcount,
          // checklistList,
          // tempList: checklistList,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        // this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  selectFilter(val, key) {
    this.setState(
      {
        [key]: val,
      },
      () => {
        this.getCheklistFrequency();
      },
    );
  }

  getchecklistcomplteiontime() {
    instance
      .get("resolve/sharedchecklistcomplteiontime")
      .then((result) => {
        this.setState({
          averagetime: result.data.result[0].averagetime,
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  viewmore() {
    instance
      .post("resolve/getongoingchecklist")
      .then((result) => {
        const drawerchecklistdata = result.data.result
          ? result.data.result
          : [];

        this.setState({
          drawerchecklistdata,
          DrawerOpen: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        // this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const { checklistdata } = this.state;

    return (
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={5}>
          <Paper className="padding16 rounded-rectangle-paper">
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <p className="small-dark t-bold margin-bottom-8">Checklists</p>
                <p className="extra-small-dark-secondary">
                  Dependent task completion time
                </p>
                {this.state.averagetime ? (
                  <div
                    className="display-flex margin-bottom-16"
                    style={{ alignItems: "center" }}
                  >
                    <span className="normal-blue t-bold margin-right-4">
                      {this.state.averagetime}
                    </span>
                    <span className="extra-small-dark-secondary">days</span>
                  </div>
                ) : (
                  <p className="small-dark-secondary">-</p>
                )}
                <p className="small-dark-secondary t-bold margin-bottom-8">
                  On-going checklists
                </p>
                <div className="display-flex" style={{ alignItems: "center" }}>
                  <span className="normal-blue t-bold margin-right-4">
                    {checklistdata &&
                      checklistdata[0] &&
                      checklistdata[0] &&
                      checklistdata[0].triggertypecount &&
                      checklistdata[0].triggertypecount.triggered}
                  </span>
                  <span className="extra-small-dark-secondary">Triggered</span>
                  <span className="normal-blue t-bold margin-left-16 margin-right-4">
                    {checklistdata &&
                      checklistdata[0] &&
                      checklistdata[0] &&
                      checklistdata[0].triggertypecount &&
                      checklistdata[0].triggertypecount.manual}
                  </span>
                  <span className="extra-small-dark-secondary">Mannual</span>
                </div>
                {checklistdata &&
                  checklistdata[0].checklist &&
                  checklistdata[0].checklist.map((item) => (
                    <div
                      className="margin-top-16 display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <p
                        className="extra-small-dark width40"
                        style={{ marginRight: 16 }}
                      >
                        {item.checklistname}
                      </p>
                      {item.assignemployeelist &&
                      item.assignemployeelist.length > 0 ? (
                        <div
                          className="display-flex"
                          style={{ alignItems: "center" }}
                        >
                          <div style={{ height: 24, display: "flex" }}>
                            {item.assignemployeelist.length > 0 &&
                              item.assignemployeelist.map(
                                (emp, index) =>
                                  index < 3 && (
                                    <div
                                      key="key"
                                      style={{
                                        width: 24,
                                        height: 24,
                                        marginLeft: 0,
                                      }}
                                    >
                                      <Tooltip
                                        title={emp.fullname}
                                        placement="top"
                                      >
                                        <Link
                                          to={`./profile/${emp.employeeid}`}
                                          target="_blank"
                                        >
                                          <div>
                                            {emp.imagepath == null ? (
                                              <img
                                                src={defaultEmp}
                                                height="24"
                                                className="team-avatar"
                                              />
                                            ) : (
                                              <img
                                                src={getFormattedImageLink(
                                                  emp.imagepath,
                                                )}
                                                height="24"
                                                className="team-avatar"
                                              />
                                            )}
                                          </div>
                                        </Link>
                                      </Tooltip>
                                    </div>
                                  ),
                              )}
                          </div>
                          {this.getCount(
                            item.assignemployeelist &&
                              item.assignemployeelist[0] &&
                              item.assignemployeelist[0].fullcount &&
                              item.assignemployeelist[0].fullcount,
                          ) > 0 ? (
                            <span className="extra-small-dark-secondary margin-left-16">
                              {this.getCount(
                                item.assignemployeelist[0].fullcount,
                              )}{" "}
                              more
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <p className="extra-small-dark-secondary">
                          No employee assigned
                        </p>
                      )}
                    </div>
                  ))}

                <p
                  // onClick={() => this.setState({ DrawerOpen: true })}
                  className="extra-small-blue cursor-pointer margin-top-8 t-bold"
                  onClick={this.viewmore}
                >
                  Show more
                </p>

                {/* {checklistdata[0].checklist.length < this.state.fullcount &&
                checklistdata[0].checklist.length ==
                  this.state.tempList.length ? (
                  <p
                    onClick={this.viewmore}
                    className="small-blue cursor-pointer"
                  >
                    Load More
                  </p>
                ) : (
                  ""
                )} */}
              </Grid>
            </Grid>
          </Paper>
          <div className="margin-top-8">
            <ShareIdea openForm={this.props.openForm} />
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={7}>
          <Paper className="padding16  rounded-rectangle-paper">
            <div
              className="margin-bottom-8 display-flex margin-top-24"
              style={{
                justifyContent: "space-between",
              }}
            >
              <p className="small-dark-secondary t-bold margin-top-12">
                {this.state.requestcounttype == 1
                  ? "Most triggered checklists"
                  : "Least triggered checklists"}
              </p>
              <div className="width60">
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.requestcounttype,
                    label: "",
                    options: this.state.checklistTypes,
                    disabled: false,
                    placeholder: "Most triggered",
                  })}
                  onChange={(val) => this.selectFilter(val, "requestcounttype")}
                />
              </div>
            </div>
            <div style={{ height: 218 }}>
              {this.state.requestCountData.length > 0 ? (
                <ResponsiveBarCanvas
                  layout="horizontal"
                  data={
                    this.state.requestCountData
                      ? this.state.requestCountData.map((x) => ({
                          Value: x.displayvalue,
                          displayname: x.displayname,
                        }))
                      : []
                  }
                  keys={["Value"]}
                  indexBy={"displayname"}
                  pixelRatio={1}
                  padding={0.8}
                  margin={{
                    top: 10,
                    right: 0,
                    bottom: 40,
                    left: 120,
                  }}
                  minValue="0"
                  maxValue={
                    Math.max(
                      ...(this.state.requestCountData
                        ? this.state.requestCountData.map((x) => x.displayvalue)
                        : []),
                    ) || "auto"
                  }
                  colors={["#0095ff"]}
                  enableLabel={true}
                  axisRight={null}
                  axisLeft={{
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "",
                    legendPosition: "middle",
                    legendOffset: 0,
                  }}
                  axisBottom={{
                    tickSize: 1,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: "Employee count",
                    tickValues:
                      Math.max(
                        ...(this.state.requestCountData
                          ? this.state.requestCountData.map(
                              (x) => x.displayvalue,
                            )
                          : []),
                      ) > 2
                        ? 4
                        : 2,
                    legendPosition: "middle",
                    legendOffset: 30,
                  }}
                  enableGridX={true}
                  enableGridY={false}
                  animate={true}
                  motionStiffness={90}
                  motionDamping={15}
                  isInteractive={true}
                />
              ) : (
                <DefaultComp
                  //  text={this.getText()}
                  heading={"No data available!"}
                  // imageSrc={emp360}
                />
              )}
            </div>
          </Paper>
        </Grid>

        <Drawer
          anchor="right"
          open={this.state.DrawerOpen}
          onClose={() => this.setState({ DrawerOpen: false })}
          style={{ padding: 40 }}
          classes={{
            paper: "planner-drawer width30 padding15",
          }}
        >
          <DrawerHeader
            header="Checklist data"
            isbackarrow={false}
            closeDrawer={() => this.setState({ DrawerOpen: false })}
          />
          {this.state.drawerchecklistdata[0].checklist &&
            this.state.drawerchecklistdata[0].checklist.map((item) => (
              <div
                className="margin-top-16 display-flex"
                style={{ alignItems: "center" }}
              >
                <p className="extra-small-dark width40">{item.checklistname}</p>
                {item.assignemployeelist && item.assignemployeelist.length > 0 ? (
                  <div
                    className="display-flex"
                    style={{ alignItems: "center" }}
                  >
                    <div style={{ height: 24, display: "flex" }}>
                      {item.assignemployeelist.length > 0 &&
                        item.assignemployeelist.map(
                          (emp, index) =>
                            index < 3 && (
                              <div
                                key="key"
                                style={{
                                  width: 24,
                                  height: 24,
                                  marginLeft: 0,
                                }}
                              >
                                <Tooltip title={emp.fullname} placement="top">
                                  <Link
                                    to={`./profile/${emp.employeeid}`}
                                    target="_blank"
                                  >
                                    <div>
                                      {emp.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="24"
                                          className="team-avatar"
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(
                                            emp.imagepath,
                                          )}
                                          height="24"
                                          className="team-avatar"
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </Tooltip>
                              </div>
                            ),
                        )}
                    </div>
                    {this.getCount(
                      item.assignemployeelist &&
                        item.assignemployeelist[0] &&
                        item.assignemployeelist[0].fullcount &&
                        item.assignemployeelist[0].fullcount,
                    ) > 0 ? (
                      <span className="extra-small-dark-secondary margin-left-16">
                        {this.getCount(item.assignemployeelist[0].fullcount)}{" "}
                        more
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <p className="extra-small-dark-secondary">
                    No employee assigned
                  </p>
                )}
              </div>
            ))}
        </Drawer>
      </Grid>
    );
  }
}

export default Hrops;
